/* 查询 */
export interface iRoomListQuery {
  start: number | null;
  end: number | null;
  game_id?: number | null;
  room_id: number | null;
  uid: number | null;
  nickname: string;
  search_status: number;
  reject_num?: number | null;
  room_name: string;
}

export interface iRoomListModel {
  id: number;
  room_name: string;
  play_mode: number;
  game_id: number;
  game_name: string;
  g_id: string;
  hot_score: number;
  host: string;
  status: number;
  review_count: number;
  reject_count: number;
  create_time: string;
  is_top: boolean;
  is_forbidden_text: boolean;
}

export interface iGameCountListQuery {
  game_id: number | null;
  game_name: string;
}
export interface iGameCountListModel {
  game_id: number | null;
  game_name: string;
  count: number;
}

export interface iDangerLevelModel {
  danger_level: number | string;
  total_reject: number | string;
  politics: number | string;
  porn: number | string;
  ban: number | string;
  violence: number | string;
}

export enum eSearchStatus {
  /* 必传1-正常 2-禁言 3-关闭 */
  NORMAL = 1,
  NOSPEAK = 2,
  CLOSE = 3,
}
export enum ePlayMode {
  /* 必传1-正常 2-禁言 3-关闭 */
  RELAYPLAY = 1,
  TOGETHERPLAY = 2,
  ALONEPLAY = 3,
}

/**
 * 危险级别 1-警告 2-禁言 3-关闭房间
 */
export enum dangerLevel {
  WARNING = 1,
  MUTED = 2,
  CLOSED = 3,
}
